import { ComponentData } from '../types'

export const assessmentData: ComponentData[] = [
  {
    id: 'c1',
    title: 'KUALITAS PRODUK INOVASI',
    weight: 0.4,
    criteria: [
      {
        id: 'c1_1',
        title: '1) Desain Antarmuka & Pengalaman Pengguna (UI/UX)',
        options: [
          {
            value: 4,
            label: 'Sangat Baik',
            description:
              'Antarmuka sangat intuitif, navigasi jelas dan konsisten. Desain visual profesional, menarik, dan mendukung kenyamanan pengguna. Aksesibilitas bagi pengguna dengan kebutuhan khusus dipertimbangkan dengan baik (misal: kontras warna, teks alternatif).',
          },
          {
            value: 3,
            label: 'Baik',
            description:
              'Antarmuka mudah digunakan, navigasi berfungsi baik. Desain visual bersih dan cukup menarik. Sebagian besar elemen mudah diakses.',
          },
          {
            value: 2,
            label: 'Cukup',
            description:
              'Antarmuka cukup dapat digunakan namun ada beberapa inkonsistensi navigasi. Desain visual kurang menarik atau terkesan "ramai". Aksesibilitas belum menjadi pertimbangan.',
          },
          {
            value: 1,
            label: 'Kurang',
            description:
              'Antarmuka membingungkan, navigasi tidak jelas. Desain visual tidak profesional dan mengganggu kenyamanan penggunaan.',
          },
        ],
      },
      {
        id: 'c1_2',
        title: '2) Fungsionalitas & Keandalan Teknis',
        options: [
          {
            value: 4,
            label: 'Sangat Baik',
            description:
              'Semua fitur dan tautan berfungsi sempurna. Waktu muat cepat, tidak ada bug atau error. Sistem memiliki fitur keamanan dasar yang terkonfigurasi dengan baik (misal: HTTPS, proteksi kata sandi, enkripsi data sederhana).',
          },
          {
            value: 3,
            label: 'Baik',
            description:
              'Hampir semua fitur berfungsi baik. Ada bug minor yang tidak mengganggu fungsi utama. Keamanan dasar sudah diupayakan meskipun belum sepenuhnya optimal.',
          },
          {
            value: 2,
            label: 'Cukup',
            description:
              'Beberapa fitur utama tidak berfungsi atau sering error. Waktu muat lambat. Aspek keamanan sangat minim.',
          },
          {
            value: 1,
            label: 'Kurang',
            description:
              'Produk tidak dapat digunakan karena banyak fitur rusak atau error total. Tidak ada pertimbangan keamanan sama sekali.',
          },
        ],
      },
      {
        id: 'c1_3',
        title: '3) Kualitas & Validitas Konten BK',
        options: [
          {
            value: 4,
            label: 'Sangat Baik',
            description:
              'Konten akurat, berbasis bukti riset terkini, dan bebas dari miskonsepsi. Konsep BK disajikan dengan adaptasi kontekstual yang sangat baik dan sesuai dengan kode etik profesi. Bahasa lugas, inklusif, dan bebas dari bias.',
          },
          {
            value: 3,
            label: 'Baik',
            description:
              'Konten akurat dan sesuai teori. Adaptasi kontekstual cukup baik. Ada sedikit ketidakkonsistenan bahasa atau istilah yang kurang tepat.',
          },
          {
            value: 2,
            label: 'Cukup',
            description:
              'Terdapat beberapa ketidakakuratan konten atau penyederhanaan yang berlebihan. Adaptasi kontekstual masih dangkal. Bahasa kurang sesuai untuk sasaran pengguna.',
          },
          {
            value: 1,
            label: 'Kurang',
            description:
              'Konten banyak mengandung miskonsepsi, tidak akurat, atau berpotensi membahayakan. Tidak sesuai kode etik.',
          },
        ],
      },
      {
        id: 'c1_4',
        title: '4) Daya Pakai & Kepraktisan (Aspek Kunci)',
        options: [
          {
            value: 4,
            label: 'Sangat Baik',
            description:
              'Produk sangat praktis digunakan oleh Guru BK/Konselor. Dapat langsung diintegrasikan ke dalam alur kerja (workflow) layanan BK tanpa modifikasi berarti. Tidak memerlukan pelatihan khusus yang rumit. Hemat waktu dan sumber daya.',
          },
          {
            value: 3,
            label: 'Baik',
            description:
              'Produk praktis digunakan, namun memerlukan sedikit penyesuaian atau panduan singkat sebelum diintegrasikan. Masih efisien bagi pengguna.',
          },
          {
            value: 2,
            label: 'Cukup',
            description:
              'Produk bisa digunakan, tetapi memerlukan usaha lebih dari pengguna. Alur kerja terasa rumit atau memakan waktu yang tidak efisien.',
          },
          {
            value: 1,
            label: 'Kurang',
            description:
              'Produk tidak praktis, sangat rumit, atau tidak relevan dengan kebutuhan dan rutinitas Guru BK/Konselor di lapangan.',
          },
        ],
      },
    ],
  },
  {
    id: 'c2',
    title: 'PROSES PENGEMBANGAN & PENERAPAN LITERASI TIK',
    weight: 0.3,
    criteria: [
      {
        id: 'c2_1',
        title: '1) Metodologi Pengembangan',
        options: [
          {
            value: 4,
            label: 'Sangat Baik',
            description:
              'Menerapkan model pengembangan sistem/instruksional (ADDIE, Design Thinking, dll.) secara sistematis, ketat, dan terdokumentasi dengan baik. Setiap tahapan memiliki dasar keputusan yang jelas.',
          },
          {
            value: 3,
            label: 'Baik',
            description:
              'Menerapkan tahapan model pengembangan dengan baik, meskipun dokumentasi atau ketelitian pada beberapa tahap masih kurang.',
          },
          {
            value: 2,
            label: 'Cukup',
            description:
              'Tahapan pengembangan tidak sistematis, banyak langkah yang terlewat. Dokumentasi minim.',
          },
          {
            value: 1,
            label: 'Kurang',
            description:
              'Tidak ada metodologi yang jelas. Proses pengembangan bersifat acak dan asal jadi.',
          },
        ],
      },
      {
        id: 'c2_2',
        title: '2) Analisis Kebutuhan Berbasis Data',
        options: [
          {
            value: 4,
            label: 'Sangat Baik',
            description:
              'Melakukan asesmen kebutuhan secara komprehensif menggunakan metode yang tepat (survei, wawancara, studi literatur). Data dianalisis secara tajam dan menjadi dasar kuat bagi setiap keputusan desain.',
          },
          {
            value: 3,
            label: 'Baik',
            description:
              'Melakukan asesmen kebutuhan dengan metode yang cukup baik. Data digunakan sebagai dasar pengembangan, meskipun belum sepenuhnya mendalam.',
          },
          {
            value: 2,
            label: 'Cukup',
            description:
              'Asesmen kebutuhan dilakukan secara minimal. Hubungan antara data dan keputusan desain kurang jelas.',
          },
          {
            value: 1,
            label: 'Kurang',
            description:
              'Tidak melakukan analisis kebutuhan. Produk dikembangkan hanya berdasarkan asumsi pribadi.',
          },
        ],
      },
      {
        id: 'c2_3',
        title: '3) Ketepatan Pemilihan & Pemanfaatan TIK',
        options: [
          {
            value: 4,
            label: 'Sangat Baik',
            description:
              'Memilih platform dan alat TIK yang paling tepat, efisien, dan berkelanjutan untuk memecahkan masalah yang diidentifikasi. Mampu menjelaskan kelebihan dan kekurangan pilihan teknologinya secara kritis dibanding alternatif lain.',
          },
          {
            value: 3,
            label: 'Baik',
            description:
              'Pilihan teknologi cukup tepat, namun belum sepenuhnya optimal. Argumentasi pemilihan alat masih bersifat permukaan.',
          },
          {
            value: 2,
            label: 'Cukup',
            description:
              'Pilihan teknologi kurang tepat, terlalu rumit, atau terlalu sederhana untuk tujuan yang ingin dicapai.',
          },
          {
            value: 1,
            label: 'Kurang',
            description:
              'Pilihan teknologi sangat tidak tepat dan kontraproduktif terhadap tujuan inovasi.',
          },
        ],
      },
      {
        id: 'c2_4',
        title: '4) Penerapan Etika & Keamanan Digital',
        options: [
          {
            value: 4,
            label: 'Sangat Baik',
            description:
              'Secara proaktif mengidentifikasi potensi risiko etis dan keamanan digital sejak awal. Menerapkan strategi mitigasi yang ketat (misal: protokol informed consent digital, data anonymization).',
          },
          {
            value: 3,
            label: 'Baik',
            description:
              'Memahami isu etika dan keamanan digital, namun penerapannya masih bersifat reaktif atau belum menyeluruh.',
          },
          {
            value: 2,
            label: 'Cukup',
            description:
              'Pertimbangan etika dan keamanan digital sangat minim. Hanya terfokus pada aspek teknis tanpa memikirkan dampaknya pada pengguna.',
          },
          {
            value: 1,
            label: 'Kurang',
            description:
              'Mengabaikan sama sekali aspek etika dan keamanan digital. Produk berpotensi melanggar kode etik atau membahayakan data pengguna.',
          },
        ],
      },
    ],
  },
  {
    id: 'c3',
    title: 'VALIDASI PRODUK & KESIAPAN PUBLIKASI',
    weight: 0.2,
    criteria: [
      {
        id: 'c3_1',
        title: '1) Validasi Ahli & Uji Pengguna',
        options: [
          {
            value: 4,
            label: 'Sangat Baik',
            description:
              'Melibatkan minimal dua ahli (Ahli BK dan Ahli TIK/Media) dan melakukan uji coba kepada calon pengguna (min. 3 Guru BK/Konselor). Instrumen validasi terstandar dan hasil dianalisis secara tepat.',
          },
          {
            value: 3,
            label: 'Baik',
            description:
              'Melibatkan ahli dan calon pengguna, namun jumlah atau prosesnya belum optimal. Analisis data validasi cukup baik.',
          },
          {
            value: 2,
            label: 'Cukup',
            description:
              'Hanya melibatkan satu pihak (ahli atau pengguna) secara terbatas. Analisis data kurang mendalam.',
          },
          {
            value: 1,
            label: 'Kurang',
            description:
              'Tidak melakukan validasi ahli maupun uji coba pengguna.',
          },
        ],
      },
      {
        id: 'c3_2',
        title: '2) Bukti Daya Pakai & Kepuasan Pengguna',
        options: [
          {
            value: 4,
            label: 'Sangat Baik',
            description:
              'Hasil uji coba menunjukkan tingkat daya pakai (skor SUS/UEQ, dll) dan kepuasan yang tinggi. Pengguna menilai produk ini "sangat membantu" dan "akan digunakan" dalam pekerjaan mereka.',
          },
          {
            value: 3,
            label: 'Baik',
            description:
              'Hasil uji coba menunjukkan produk cukup mudah digunakan dan bermanfaat. Ada beberapa saran perbaikan minor.',
          },
          {
            value: 2,
            label: 'Cukup',
            description:
              'Hasil uji coba menunjukkan banyak kendala usabilitas. Pengguna ragu untuk mengadopsi produk.',
          },
          {
            value: 1,
            label: 'Kurang',
            description:
              'Produk dinilai tidak berguna atau sangat sulit digunakan oleh pengguna.',
          },
        ],
      },
      {
        id: 'c3_3',
        title: '3) Kualitas Panduan Pengguna (User Manual)',
        options: [
          {
            value: 4,
            label: 'Sangat Baik',
            description:
              'Tersedia panduan pengguna (tertulis/video) yang sangat jelas, ringkas, dan profesional. Panduan memungkinkan pengguna awam untuk langsung dapat menggunakan produk secara mandiri. Terdapat troubleshooting dasar.',
          },
          {
            value: 3,
            label: 'Baik',
            description:
              'Panduan cukup jelas dan membantu. Ada beberapa langkah yang penjelasannya kurang detail.',
          },
          {
            value: 2,
            label: 'Cukup',
            description:
              'Panduan ada tetapi sulit dipahami atau tidak lengkap.',
          },
          {
            value: 1,
            label: 'Kurang',
            description:
              'Tidak ada panduan pengguna atau panduan yang ada justru membingungkan.',
          },
        ],
      },
      {
        id: 'c3_4',
        title: '4) Kesiapan Pameran Publik (Exhibition Readiness)',
        options: [
          {
            value: 4,
            label: 'Sangat Baik',
            description:
              'Materi presentasi (poster, demo) dikemas secara sangat profesional, komunikatif, dan mampu menjual nilai inovasi dengan kuat kepada publik. Mahasiswa mampu mendemonstrasikan dan menjawab pertanyaan dengan sangat fasih.',
          },
          {
            value: 3,
            label: 'Baik',
            description:
              'Materi presentasi baik dan cukup meyakinkan. Mahasiswa mampu menjelaskan produknya dengan baik.',
          },
          {
            value: 2,
            label: 'Cukup',
            description:
              'Materi presentasi kurang menarik atau kurang informatif. Mahasiswa kesulitan menjelaskan nilai unggul produknya.',
          },
          {
            value: 1,
            label: 'Kurang',
            description:
              'Materi presentasi sangat buruk dan gagal mengomunikasikan inovasi. Mahasiswa tidak menguasai produknya sendiri.',
          },
        ],
      },
    ],
  },
  {
    id: 'c4',
    title: 'PERTANGGUNGJAWABAN AKADEMIK',
    weight: 0.1,
    criteria: [
      {
        id: 'c4_1',
        title: '1) Sistematika & Tata Tulis Laporan',
        options: [
          {
            value: 4,
            label: 'Sangat Baik',
            description:
              'Laporan lengkap, sistematis, dan ditulis dengan tata bahasa Indonesia yang baku dan efektif. Mengikuti kaidah penulisan ilmiah dengan kutipan dan daftar pustaka yang konsisten (APA Style).',
          },
          {
            value: 3,
            label: 'Baik',
            description:
              'Laporan lengkap dan cukup sistematis. Ada sedikit kesalahan tata bahasa atau inkonsistensi pengutipan.',
          },
          {
            value: 2,
            label: 'Cukup',
            description:
              'Laporan tidak lengkap, sistematika kacau. Banyak kesalahan bahasa dan pengutipan.',
          },
          {
            value: 1,
            label: 'Kurang',
            description:
              'Laporan sangat buruk dan tidak memenuhi standar akademik.',
          },
        ],
      },
      {
        id: 'c4_2',
        title: '2) Kedalaman Analisis & Refleksi Kritis',
        options: [
          {
            value: 4,
            label: 'Sangat Baik',
            description:
              'Pembahasan sangat tajam, menghubungkan temuan dengan kerangka teori literasi TIK dan praktik BK secara kritis. Refleksi menunjukkan pembelajaran mendalam, termasuk mengakui keterbatasan solusi dan potensi riset lanjutan.',
          },
          {
            value: 3,
            label: 'Baik',
            description:
              'Pembahasan cukup baik dan ada upaya refleksi. Analisis masih bersifat deskriptif dan belum sepenuhnya kritis.',
          },
          {
            value: 2,
            label: 'Cukup',
            description:
              'Pembahasan hanya mengulang data. Tidak ada analisis mendalam atau refleksi yang berarti.',
          },
          {
            value: 1,
            label: 'Kurang',
            description:
              'Tidak ada pembahasan. Laporan hanya bersifat teknis dan dangkal.',
          },
        ],
      },
    ],
  },
]
